// NOTE: this method is duplicated from `@gig/magic-account/dist/util`
function containsLetter(value) {
    return /[a-zA-Z]/.test(value);
}

export { containsLetter };
